import { render, staticRenderFns } from "./MessagesCard.vue?vue&type=template&id=3b9a53cc&"
import script from "./MessagesCard.vue?vue&type=script&lang=js&"
export * from "./MessagesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports